import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function ProblemReal() {
  return <section className="bg-[#FDF8F3] py-20 px-6" data-id="element-299">
      <div className="max-w-[680px] mx-auto" data-id="element-300">
        <FadeIn data-id="element-301">
          <h2 className="font-serif text-3xl text-[#1B2A4A] mb-8 text-center" data-id="element-302">
            El problema real{' '}
            <span className="italic text-[#3BBFAD] text-2xl block mt-1" data-id="element-303">
              (nadie lo dice así)
            </span>
          </h2>

          <div className="space-y-6 text-[#1B2A4A]/80 text-lg leading-relaxed" data-id="element-304">
            <p data-id="element-305">El problema no es que “no hay recursos”.</p>
            <p data-id="element-306">El problema es que la mayoría de recursos son:</p>
            <ul className="space-y-3 pl-4" data-id="element-307">
              <li className="flex gap-3 items-start" data-id="element-308">
                <span className="text-[#F5A623] text-xl font-bold" data-id="element-309">•</span>
                <span data-id="element-310">Demasiado clínicos (no sabes qué hacer mañana)</span>
              </li>
              <li className="flex gap-3 items-start" data-id="element-311">
                <span className="text-[#F5A623] text-xl font-bold" data-id="element-312">•</span>
                <span data-id="element-313">
                  Demasiado “de redes” (historias y opiniones, cero estructura)
                </span>
              </li>
              <li className="flex gap-3 items-start" data-id="element-314">
                <span className="text-[#F5A623] text-xl font-bold" data-id="element-315">•</span>
                <span data-id="element-316">
                  O te mandan al pediatra sin ayudarte a hablar el idioma
                  correcto
                </span>
              </li>
            </ul>

            <div className="bg-white p-6 rounded-xl border-l-4 border-[#F5A623] shadow-sm mt-8" data-id="element-317">
              <p className="font-medium mb-4" data-id="element-318">
                Y cuando llegas a la cita sin ejemplos claros, pasa esto:
              </p>
              <ul className="list-decimal pl-5 space-y-2 text-[#1B2A4A]/70" data-id="element-319">
                <li data-id="element-320">Te dicen “observemos”</li>
                <li data-id="element-321">Tú sales con la misma ansiedad</li>
                <li data-id="element-322">Y el tiempo pasa</li>
              </ul>
            </div>

            <p className="text-xl font-serif text-[#1B2A4A] text-center pt-6" data-id="element-323">
              La Ruta Clara está diseñada para que llegues con: <br data-id="element-324" />
              <span className="text-[#3BBFAD] font-bold" data-id="element-325">
                patrones observables + ejemplos + un pedido concreto.
              </span>
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}